export const APPROVED = 0;
export const PENDING = 1;
export const PROCESSING = 2;
export const ERROR = 3;
export const REJECTED = 4;
export const MORE_INFO = 5;
export const DELETED = 6;
